import * as types from '../actions/action-types';

export function getEditPolicyResults(data) {
  	return {
    	type: types.GET_EDITPOLICY_RES,
    	data
  	};
}

export function getEditPolicyOptions(data) {
  	return {
    	type: types.GET_EDITPOLICY_OPT,
    	data
  	};
}

export function getSeatChartResults(data) {
  	return {
    	type: types.GET_SEATCHART_DETAIL,
    	data
  	};
}

export function getSearchResults(data) {
  return {
    type: types.GET_SEARCH_RES,
    data
  };
} 

export function getCheckBoxDetails(data) {
  return {
    type: types.GET_CHECKBOX_RES,
    data
  };
}

export function getPrePostCheckBox(data) {
  return {
    type: types.GET_PREPOST_CHECKBOX_RES,
    data
  };
}

export function updateRouteInfo(data) {
  return {
    type: types.UPDATE_ROUTE_INFO,
    data
  };
}

export function toggleFinalSave(data) {
  return {
    type: types.TOGGLE_FINAL_SAVE,
    data
  };
}

export function saveEditDetails(data) {
  return {
    type: types.SAVE_EDIT_DETAILS,
    data
  };
}

export function getOldSeat(data) {
  return {
    type: types.GET_OLD_SEAT,
    data
  };
}


export function updateSeatChart(rsid, data) {
  return {
    type: types.UPDATE_SEAT_CHART,
    rsid, data
  };
}

export function updateSeatChartDet(rsid, data) {
  return {
    type: types.UPDATE_SEAT_CHART_DET,
    rsid, data
  };
}

export function updateHeaderText(text, data, text1, data1, text2, data2) {
  return {
    type: types.UPDATE_HEADER_TEXT,
    text, data, text1, data1, text2, data2
  };
}

export function updateCheckoutDet(data) {
  return {
    type: types.UPDATE_CHECKOUT_DET,
    data
  };
}

export function updateFilterReset() {
  return {
    type: types.UPDATE_FILTER_RESET
  };
}

export function updateUserGender(info, param, seat, data) {
  let type = types.UPDATE_USER_GENDER
  return {
    type, param, seat, data
  }
}

export function getreschedulecharge(data){
  return{
    type:types.GET_RESCHEDULE_CHARGES,
    data
  };
}

export function getEditPolicyData(data){
  return{
    type:types.GET_EDITPOLICY_DATA,
    data
  };
}

export function setNewDepartDate(data){
  return{
    type:types.SET_NEW_DEPART_DATE,
    data
  };
}


// WEBPACK FOOTER //
// ./src/actions/editPolicy-actions.js